import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'
import { Formik } from 'formik'
import * as Yup from 'yup'

import setPerksWaitingPeriod, {
  SetPerksWaitingPeriodRequest,
} from 'core/application/adminDashboard/benefitDetails/design/perks/productClass/setWaitingPeriod'

import Radio from 'common/components/dataEntry/formik/FormikRadioField'
import Alert from 'common/components/feedback/Alert'

import useCommandRequest from 'common/hooks/useCommandRequest'

import { BaseComponentProps } from '../../../../../common/productClassWizardModal/Common'

import './styles.less'

export type SetWaitingPeriodProps = {
  id: string
  waitingPeriod: number
}

export default (props: BaseComponentProps<SetWaitingPeriodProps>) => {
  const { t: translate } = useTranslation()

  const { bindSubmitFormHandler } = props
  const [sendCommand] = useCommandRequest()
  const [initialValues] = useState<SetPerksWaitingPeriodRequest>({
    waitingPeriod: props.state.waitingPeriod,
    productClassId: props.state.id,
  })

  const onSubmit = async (values: any) => {
    const request = {
      ...values,
      productClassId: props.state.id,
    }

    const result = await sendCommand(() => setPerksWaitingPeriod(request))

    if (result.completed) {
      props.finish()
    } else {
      props.setIsSubmiting(false)
    }
  }

  useEffect(() => {
    props.setIsFormValid(formValidator(translate).isValidSync(initialValues))
  }, [])

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={Yup.object({})}
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={(values) => {
        const isValid: boolean = formValidator(translate).isValidSync(values)
        props.setHasDirtyData(isValid)
        props.setIsFormValid(isValid)
        return {}
      }}
    >
      {(formik) => {
        const { handleSubmit, submitForm } = formik
        bindSubmitFormHandler(submitForm)
        return (
          <form autoComplete="off" onSubmit={handleSubmit} className="set-perks-waiting-period-wrapper">
            <Row>
              <Col span={24}>
                <h5 className="select_class_info mb-24">
                  {translate('admin-dashboard.benefit-details.class-design.perks-waiting-period.header')}
                </h5>
              </Col>
            </Row>

            <div>
              <Alert
                showIcon
                type="info"
                className={'mb-24'}
                message={''}
                description={translate('admin-dashboard.benefit-details.class-design.perks-waiting-period.alert-desc')}
              />
            </div>

            <Radio.Group name="waitingPeriod" className="w-100" defaultValue={props.state.waitingPeriod}>
              <Row gutter={10}>
                <Col span={24} className={'mb-8'}>
                  <Radio.Button value={0}>
                    {translate('admin-dashboard.benefit-details.class-design.perks-waiting-period.no-waiting')}
                  </Radio.Button>
                </Col>
                <Col span={24} className={'mb-8'}>
                  <Radio.Button value={30}>
                    {translate('admin-dashboard.benefit-details.class-design.perks-waiting-period.30-waiting')}
                  </Radio.Button>
                </Col>
                <Col span={24} className={'mb-8'}>
                  <Radio.Button value={60}>
                    {translate('admin-dashboard.benefit-details.class-design.perks-waiting-period.60-waiting')}
                  </Radio.Button>
                </Col>
                <Col span={24}>
                  <Radio.Button value={90}>
                    {translate('admin-dashboard.benefit-details.class-design.perks-waiting-period.90-waiting')}
                  </Radio.Button>
                </Col>
              </Row>
            </Radio.Group>
          </form>
        )
      }}
    </Formik>
  )
}

const formValidator = (translate: any) =>
  Yup.object({
    waitingPeriod: Yup.number()
      .required(translate('general.required'))
      .oneOf([0, 30, 60, 90])
      .typeError(translate('admin-dashboard.benefit-details.class-design.errors.enter-number')),
  })
